module.exports = __webpack_public_path__ + "static/media/sith.8bf0cb46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sith.jpg
// module id = 42
// module chunks = 0